import React from 'react';
import { Col, Form, Row, Typography, Select, Checkbox } from 'antd';
import uuid from 'react-uuid';
import { useTranslation } from 'react-i18next';
import Helpers from 'helpers';

const { Option } = Select;

const ShopSection = ({ shoppingCenters, companyCategories }) => {
  const { t } = useTranslation();

  return (
    <Row gutter={24}>
      <Col span={6}>
        <Typography.Title level={3}>{t('Shop')}</Typography.Title>
      </Col>
      <Col span={6}>
        <Form.Item label={t('Shopping center')} name='shopping_center_id'>
          <Select
            {...Helpers.addSearchProps()}
            placeholder={t('Shopping center')}
          >
            <Option value=''>{t('Selezioni opzione')}</Option>
            {shoppingCenters.map(({ value, title }) => (
              <Option key={uuid()} value={value}>
                {title}
              </Option>
            ))}
          </Select>
        </Form.Item>
      </Col>

      <Col offset={6} span={18}>
        <Form.Item label={t('CATEGORIE')} name='company_category_ids'>
          <Checkbox.Group>
            {companyCategories.map((i) => (
              <Row key={uuid()}>
                <Col>
                  <Checkbox value={i.value}>{i.title}</Checkbox>
                </Col>
              </Row>
            ))}
          </Checkbox.Group>
        </Form.Item>
      </Col>
    </Row>
  );
};

export default React.memo(ShopSection);
